<template>
  <div>    
    <el-dialog title="确认拉黑" :visible.sync="dialogFormVisible">
      <el-form>
        <el-form-item label="备注">
          <el-input v-model="remark" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="getBlack">确 定</el-button>
      </div>
    </el-dialog>
    <p class="user_title">账号信息</p>
    <table style="border-collapse: collapse" class="account-number">
      <tr>
        <th>uid</th>
        <th>账号</th>
        <th>注册时间</th>
        <th>注册设备ID</th>
        <th>注册IP</th>
        <th>注册包ID</th>
        <th>注册方式</th>
        <th>账号状态</th>
        <th>封禁/解封原因</th>
      </tr>
      <tr>
        <td>{{ tableData.id }}</td>
        <td>{{ tableData.username }}</td>
        <td>{{ tableData.created_at }}</td>
        <td>
          <div v-if="tableData.user_info != null">
            {{ tableData.user_info.register_gdid }}
          </div>
        </td>
        <td>
          <div v-if="tableData.user_info != null">
            {{ tableData.user_info.register_ip }}
          </div>
        </td>
        <td>{{ tableData.game_channel_package_id }}</td>
        <td>
          <div v-if="tableData.channels != null">
            {{ tableData.channels.name }}
          </div>
        </td>
        <td>
          <div v-if="tableData.status == '封禁'">
            {{ tableData.status }}
            <el-button
              type="primary"
              plain
              style="margin-top: 10px"
              @click="unseal()"
              >解封</el-button
            >
          </div>
          <div v-if="tableData.status == '正常'">
            {{ tableData.status }}
          </div>
        </td>
        <td>{{ tableData.status_reason }}</td>
      </tr>
      <tr>
        <th>真实姓名</th>
        <th>身份证号</th>
        <th>手机号</th>
        <th>最后登录时间</th>
        <th>最后登录设备ID</th>
        <th>最后登录IP</th>
        <th>累计充值金额</th>
        <th>代币余额</th>
        <th>设备号</th>
        <th>修改渠道包</th>
      </tr>
      <tr>
        <td>{{ tableData.real_name }}</td>
        <td>{{ tableData.id_card }}</td>
        <td>
          <div v-if="tableData.phone != '' && tableData.is_phone_blacked == 0">
            {{ tableData.phone }}
            <el-button
              type="primary"
              plain
              style="margin-top: 10px"
              @click="openBlackDialog('Phone')"
              >拉黑</el-button
            >
          </div>
          <div v-if="tableData.phone != '' && tableData.is_phone_blacked == 1">
            {{ tableData.phone }}
            <el-button
              type="danger"
              plain
              style="margin-top: 10px"
              @click="getcancelBlackPhone"
              >取消拉黑</el-button
            >
          </div>
          <div v-if="tableData.phone == ''">
            {{ tableData.phone }}
          </div>
        </td>
        <td>{{ tableData.last_login_at }}</td>
        <td>
          <div
            v-if="tableData.user_info != null && tableData.is_gdid_blacked == 0"
          >
            {{ tableData.user_info ? tableData.user_info.last_login_gdid : "" }}
            <el-button
              type="primary"
              plain
              style="margin-top: 10px"
              @click="openBlackDialog('Gdid')"
              >拉黑</el-button
            >
          </div>
          <div
            v-if="tableData.user_info != null && tableData.is_gdid_blacked == 1"
          >
            {{ tableData.user_info ? tableData.user_info.last_login_gdid : "" }}
            <el-button
              type="danger"
              plain
              style="margin-top: 10px"
              @click="getcancelGdid"
              >取消拉黑</el-button
            >
          </div>
          <div v-if="tableData.user_info == null">
            {{ tableData.user_info ? tableData.user_info.last_login_gdid : "" }}
          </div>
        </td>
        <td>
          <div
            v-if="tableData.user_info != null && tableData.is_ip_blacked == 0"
          >
            {{ tableData.user_info ? tableData.user_info.last_login_ip : "" }}
            <el-button
              type="primary"
              plain
              style="margin-top: 10px"
              @click="openBlackDialog('Ip')"
              >拉黑</el-button
            >
          </div>
          <div
            v-if="tableData.user_info != null && tableData.is_ip_blacked == 1"
          >
            {{ tableData.user_info ? tableData.user_info.last_login_ip : "" }}
            <el-button
              type="danger"
              plain
              style="margin-top: 10px"
              @click="getcancelBlackIp"
              >取消拉黑</el-button
            >
          </div>
          <div v-if="tableData.user_info == null">
            {{ tableData.user_info ? tableData.user_info.last_login_ip : "" }}
          </div>
        </td>
        <td>{{ tableData.money }}</td>
        <td>{{ tableData.balance }}</td>
        <td>
          <div
            v-if="tableData.user_info != null && tableData.is_gdid_blacked == 0"
          >
            {{ tableData.user_info ? tableData.user_info.last_login_gdid : "" }}
            <el-button
              type="primary"
              plain
              style="margin-top: 10px"
              @click="openBlackDialog('Gdid')"
              >拉黑</el-button
            >
          </div>
          <div
            v-if="tableData.user_info != null && tableData.is_gdid_blacked == 1"
          >
            {{ tableData.user_info ? tableData.user_info.last_login_gdid : "" }}
            <el-button
              type="danger"
              plain
              style="margin-top: 10px"
              @click="getcancelGdid"
              >取消拉黑</el-button
            >
          </div>
          <div v-if="tableData.user_info == null">
            {{ tableData.user_info ? tableData.user_info.last_login_gdid : "" }}
          </div>
        </td>
        <td>
          <el-button
            type="primary"
            plain
            style="margin-top: 10px"
            @click="channelChange"
            >修改</el-button
          >
        </td>
      </tr>
    </table>

    <p class="user_title">相关操作</p>
    <div class="operate">
      <div>
        <el-select
          v-model="status_reason"
          placeholder="请选择封禁原因/解封原因"
        >
          <el-option
            v-for="item in reasonsList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <div v-if="tableData.status == '正常'">
          <el-date-picker
            type="datetime"
            v-model="restored_at"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="解封时间"
            default-time="00:00:00"
          >
          </el-date-picker>
          <el-button type="primary" @click="close()">封禁</el-button>
        </div>
        <div v-if="tableData.status == '禁用'">
          <el-button type="primary">解封</el-button>
        </div>
      </div>
      <div>
        <el-input placeholder="请输入手机号" v-model="phone"></el-input>
        <el-button type="primary" @click="changePhone">换绑手机</el-button>
      </div>
    </div>

    <!-- 修改渠道包 -->
    <el-dialog
      title="修改渠道包"
      :visible.sync="changeDialogVisible"
      width="30%"
      class="changeChange"
    >
      <el-form>
        <el-form-item label="游戏:">
          <el-select
            v-model="changeValue.game_id"
            filterable
            clearable
            placeholder="请选择"
            @change="selectChannel"
          >
            <el-option
              v-for="item in gamesList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="转至:">
          <el-select
            v-model="changeValue.game_channel_package_id"
            filterable
            clearable
            placeholder="渠道包选择"
          >
            <el-option
              v-for="item in channelInfoList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="changeDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="editChannel()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import fetch from "@/assets/js/axios.js";
import { debounce } from "@/assets/js/public.js";
import { throttle } from "@/assets/js/public.js";

export default {
  name: "userDetails",
  components: {},
  data() {
    return {
      id: "",
      loadingData: false,
      changeDialogVisible: false,
      tableData: {},
      status_reason: "",
      restored_at: "",
      phone: "",
      reasonsList: [],
      gamesList: [],
      changeValue: {
        game_id: "",
        game_channel_package_id: "",
      },
      channelInfoList: [],
      dialogFormVisible: false,
      remark: '',
      blackType: 'phone'
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.reasons();
    this.getGameList();
    this.getUserDetailsList();
  },
  activated () {
    if (this.id !== this.$route.query.id) {
      this.id = this.$route.query.id;
      this.reasons();
      this.getGameList();
      this.getUserDetailsList();
    }
  },
  methods: {
    openBlackDialog (type) {
      this.blackType = type
      this.dialogFormVisible = true
    },
    async getBlack () {
      await this['getblack'+ this.blackType]()
      this.dialogFormVisible = false
      this.remark = ''
    },
    close() {
      if (this.status_reason == "") {
        this.$message.error("请选择封禁原因/解封原因");
        return false;
      }
      let status = 0;
      if (this.tableData.status == "正常") {
        if (this.restored_at == "") {
          this.$message.error("请选择解封时间");
          return false;
        }
        status = 1;
      }
      fetch({
        url: "/admin/users/banning",
        method: "GET",
        params: {
          user_id: this.id,
          status: status,
          status_reason: this.status_reason,
          restored_at: this.restored_at,
        },
      })
        .then((res) => {
          if (res.data.status) {
            this.$message.success("封禁成功！");
          }
          this.getUserDetailsList();
        })
        .finally(() => {
          this.loadingData = false;
        });
    },
    unseal() {
      let unseal_status = 1;
      if (this.tableData.status == "封禁") {
        unseal_status = 0;
      }
      fetch({
        url: "/admin/users/banning",
        method: "GET",
        params: {
          user_id: this.id,
          status: unseal_status,
          status_reason: 0,
        },
      })
        .then((res) => {
          if (res.data.status) {
            this.$message.success("解封成功！");
          }
          this.getUserDetailsList();
        })
        .finally(() => {
          this.loadingData = false;
        });
    },

    changePhone() {
      fetch({
        url: "/admin/users/change_phone",
        method: "GET",
        params: {
          user_id: this.id,
          phone: this.phone,
        },
      })
        .then((res) => {
          if (res.data.status) {
            this.$message.success("换绑成功");
          }
          this.getUserDetailsList();
        })
        .finally(() => {
          this.loadingData = false;
        });
    },

    reasons() {
      fetch({
        url: "/admin/users/status_reason",
        method: "GET",
      }).then((res) => {
        this.reasonsList = res.data.data;
      });
    },

    // 拉黑用户ip
    getblackIp() {
      fetch({
        url: "/admin/users/black_ip",
        method: "GET",
        params: {
          user_id: this.id,
          remark: this.remark,
        },
      }).then((res) => {
        if (res.data.status) {
          this.$message({
            type: "success",
            message: "拉黑用户IP成功！",
          });
          this.getUserDetailsList();
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    // 取消拉黑用户ip
    getcancelBlackIp() {
      fetch({
        url: "/admin/users/cancel_black_ip",
        method: "GET",
        params: {
          user_id: this.id,
        },
      }).then((res) => {
        if (res.data.status) {
          this.$message({
            type: "success",
            message: "取消拉黑用户IP成功！",
          });
          this.getUserDetailsList();
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    // 拉黑用户phone
    getblackPhone() {
      fetch({
        url: "/admin/users/black_phone",
        method: "GET",
        params: {
          user_id: this.id,
          remark: this.remark,
        },
      }).then((res) => {
        if (res.data.status) {
          this.$message({
            type: "success",
            message: "拉黑用户phone成功！",
          });
          this.getUserDetailsList();
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    // 取消拉黑用户phone
    getcancelBlackPhone() {
      fetch({
        url: "/admin/users/cancel_black_phone",
        method: "GET",
        params: {
          user_id: this.id,
        },
      }).then((res) => {
        if (res.data.status) {
          this.$message({
            type: "success",
            message: "取消拉黑用户phone成功！",
          });
          this.getUserDetailsList();
        } else {
          this.$message.error(res.data.message);
        }
      });
    },

    // 拉黑设备号
    getblackGdid() {
      fetch({
        url: "/admin/users/black_gdid",
        method: "GET",
        params: {
          user_id: this.id,
          remark: this.remark,
        },
      }).then((res) => {
        if (res.data.status) {
          this.$message({
            type: "success",
            message: "拉黑用户设备号成功！",
          });
          this.getUserDetailsList();
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    // 取消拉黑用户设备号
    getcancelGdid() {
      fetch({
        url: "/admin/users/cancel_black_gdid",
        method: "GET",
        params: {
          user_id: this.id,
        },
      }).then((res) => {
        if (res.data.status) {
          this.$message({
            type: "success",
            message: "取消拉黑用户设备号成功！",
          });
          this.getUserDetailsList();
        } else {
          this.$message.error(res.data.message);
        }
      });
    },

    // 修改渠道包
    channelChange() {
      this.changeDialogVisible = true;
    },
    // 用户所在游戏选择
    getGameList() {
      fetch({
        url: "/admin/chengeUserChannelInfo/Gamelist",
        method: "GET",
        params: {
          user_id: this.id,
        },
      }).then((res) => {
        if (res.data.status) {
          this.gamesList = res.data.data.filter(item => item)
        }
      });
    },
    // 查看游戏渠道包
    getChannelInfo(vid) {
      fetch({
        url: "/admin/chengeUserChannelInfo/GamePackageList",
        method: "GET",
        params: {
          game_id: vid,
        },
      }).then((res) => {
        if (res.data.status) {
          this.channelInfoList = res.data.data;
        }
      });
    },
    // 根据游戏显示对应的渠道
    selectChannel(vid) {
      this.getChannelInfo(vid);
    },
    // 修改渠道包提交操作
    editChannel() {
      fetch({
        url: "/admin/chengeUserChannelInfo/action",
        method: "GET",
        params: {
          user_id: this.id,
          oringin_package_id: this.tableData.game_channel_package_id,
          ...this.changeValue,
        },
      }).then((res) => {
        if (res.data.status) {
          this.$message({
            type: "success",
            message: "修改渠道包成功~",
          });
          this.changeDialogVisible = false
          this.getUserDetailsList();
        } else {
          this.$message.error(res.data.message);
        }
      });
    },

    // 展示游戏列表数据
    getUserDetailsList(reload = false) {
      this.loadingData = true;
      fetch({
        url: "/admin/users/details",
        method: "GET",
        params: {
          user_id: this.id,
        },
      })
        .then((res) => {
          if (res.data.status) {
            this.tableData = res.data.data;
          }
        })
        .finally(() => {
          this.loadingData = false;
        });
    },
  },
};
</script>
<style lang="less">
.pagination {
  text-align: right;
  margin-top: 20px;
  padding-bottom: 20px;
}

.list-hd {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;

  .el-input-group {
    width: 370px;
  }
}
.account-number {
  tr {
    th,
    td {
      width: 130px;
      padding: 12px 10px;
      text-align: center;
      border: 1px solid rgba(0, 0, 0, 0.1);
      box-sizing: border-box;
      color: rgba(0, 0, 0, 0.5);
    }
  }
}
.operate {
  display: flex;
  .el-input {
    width: 300px;
    margin-right: 30px;
  }
  .el-select {
    margin-bottom: 30px;
  }
}
.operate > div {
  &:first-child {
    margin-right: 60px;
  }
}
.user_title {
  color: rgba(0, 0, 0, 0.6);
}
.changeChange {
  .el-form-item {
    display: flex;
    justify-content: center;
    .el-select {
      width: 260px;
    }
  }
}
</style>
